import { render } from "./info-popup.vue?vue&type=template&id=51291535"
import script from "./info-popup.vue?vue&type=script&lang=js"
export * from "./info-popup.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Cater-Frontend\\cater\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__